import actionTypes from '../constants/actionTypes';
import { updateObject } from '../../utils';

const initialState = {
  loading: false,
  error: null,
  sections: {},
};

const sectionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.START_GET_SECTION:
      return updateObject(state, { loading: true });
    case actionTypes.SUCCESS_GET_SECTION:
      return updateObject(state, {
        loading: false,
        sections: updateObject(state.sections, {
          [action.section.link]: action.section,
        }),
        error: null,
      });
    case actionTypes.ERROR_GET_SECTION:
      return updateObject(state, {
        loading: false,
        error: null,
      });
    default:
      return state;
  }
};

export default sectionReducer;
